function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "\u692D\u5706\u5F62");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M9.5,16.3694565 L1.42382927,19.9126266 C0.754503,20.2062728 0,19.7237989 0,19.0021458 L0,1.89699933 C0,0.813588696 0.958838992,0 2.07302405,0 L16.9269759,0 C18.0411733,0 19,0.813586669 19,1.89699933 L19,19.0021458 C19,19.7237989 18.245497,20.2062728 17.5761707,19.9126266 L9.5,16.3694565 Z",
  id: "path-1"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u5DE5\\u4F5C\\u53F0/\\u89D2\\u8272\\u7BA1\\u7406/\\u5B50\\u8D26\\u53F7",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u4E3B\\u8D26\\u53F7-\\u5DE5\\u4F5C\\u53F001",
  transform: "translate(-985.000000, -15.000000)"
}, React.createElement("g", {
  id: "\\u7F16\\u7EC4-71",
  transform: "translate(985.000000, 15.000000)"
}, React.createElement("g", {
  id: "\\u692D\\u5706\\u5F62"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("use", {
  id: "\\u8499\\u7248",
  fill: "#FF8F14",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
}), React.createElement("ellipse", {
  fill: "#FCA315",
  mask: "url(#mask-2)",
  cx: 5.06666667,
  cy: 1.25,
  rx: 17.7333333,
  ry: 17.5
}), React.createElement("ellipse", {
  id: "\\u692D\\u5706\\u5F62\\u590D\\u5236",
  fill: "#FCB138",
  mask: "url(#mask-2)",
  cx: 2.53333333,
  cy: 1.25,
  rx: 13.9333333,
  ry: 11.25
}), React.createElement("ellipse", {
  id: "\\u692D\\u5706\\u5F62\\u590D\\u5236-2",
  fill: "#FFC55B",
  mask: "url(#mask-2)",
  cx: 0.633333333,
  cy: -1.25,
  rx: 9.5,
  ry: 7.5
}), React.createElement("path", {
  d: "M10.5128267,8.22203759 L12.7698202,8.22203759 C13.330113,8.22203759 13.7843201,8.66937835 13.7843201,9.22120114 C13.7843201,9.77302393 13.330113,10.2203647 12.7698202,10.2203647 L10.5128267,10.2203647 L10.5128267,12.4432387 C10.5128267,12.9950615 10.0586196,13.4424023 9.49832674,13.4424023 C8.93803388,13.4424023 8.48382678,12.9950615 8.48382678,12.4432387 L8.48382678,10.2203647 L6.22683329,10.2203647 C5.66654044,10.2203647 5.21233333,9.77302393 5.21233333,9.22120114 C5.21233333,8.66937835 5.66654044,8.22203759 6.22683329,8.22203759 L8.48382678,8.22203759 L8.48382678,5.99916355 C8.48382678,5.44734076 8.93803388,5 9.49832674,5 C10.0586196,5 10.5128267,5.44734076 10.5128267,5.99916355 L10.5128267,8.22203759 L10.5128267,8.22203759 Z",
  id: "\\u8DEF\\u5F84",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  mask: "url(#mask-2)"
})))));

var SvgSubscribeInform = function SvgSubscribeInform(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "19px",
    height: "20px",
    viewBox: "0 0 19 20",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSubscribeInform, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/subscribeInform.bdeecf63.svg";
export { ForwardRef as ReactComponent };